<template>
    <v-app-bar 
      app 
      color="white" 
      light 
      elevation="1" 
      dense 
      height="70"
      class="custom-header"
    >
      <!-- Mobile Menu Toggle REMOVED -->

      <!-- Page Title -->
      <div class="page-title ml-4">
        <h1>{{ currentRouteName }}</h1>
      </div>

      <v-spacer />

      <!-- Date & Time -->
      <div class="date-time-container d-none d-sm-flex mr-6">
        <div class="dt-item">
          <v-icon small color="grey darken-1" class="mr-1">mdi-calendar-blank</v-icon>
          <span>{{ date }}</span>
        </div>
        <div class="dt-divider mx-3"></div>
        <div class="dt-item">
          <v-icon small color="grey darken-1" class="mr-1">mdi-clock-time-four-outline</v-icon>
          <span>{{ time }}</span>
        </div>
      </div>

      <!-- User Info -->
      <div class="user-info d-flex align-center mr-4">
        <div class="text-right">
          <div class="user-name">{{ $store.getters.getUserData.user_login || 'Usuário' }}</div>
          <div class="user-role">{{ $store.getters.getUserData.role_name || 'Administrador' }}</div>
        </div>
      </div>

      <!-- Logout Button -->
      <div class="logout-section pl-4" style="border-left: 1px solid #eee">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="grey darken-1" v-bind="attrs" v-on="on" @click="logoutDialog = true">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>Sair do sistema</span>
        </v-tooltip>
      </div>

      <!-- Logout Confirmation Dialog -->
      <v-dialog v-model="logoutDialog" max-width="400">
        <v-card class="rounded-xl pa-4">
          <v-card-title class="text-h6 font-black uppercase tracking-tight grey--text text--darken-3">
            Sair do Sistema?
          </v-card-title>
          <v-card-text class="py-4 text-slate-500 font-medium">
            Tem certeza que deseja encerrar sua sessão atual e voltar para a tela de login?
          </v-card-text>
          <v-card-actions class="pt-4">
            <v-btn text class="text-capitalize font-bold grey--text" @click="logoutDialog = false">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="orange" dark class="rounded-lg px-8 font-black text-capitalize" elevation="0" @click="executeLogout">
              Confirmar Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-progress-linear
        :active="$store.getters.getLoader"
        :indeterminate="$store.getters.getLoader"
        absolute
        bottom
        color="secondary"
      ></v-progress-linear>
    </v-app-bar>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
    date: "",
    time: "",
    logoutDialog: false,
  }),
  computed: {
    currentRouteName() {
      // Get the name from the current route or from the meta title
      const name = this.$route.name;
      const path = this.$route.path;

      // Mapping for user-friendly display names
      if (path.includes('/dashboard')) return 'PAINEL';
      if (path.includes('/drivers-manager')) return 'MOTORISTAS';
      if (path.includes('/vehicles-manager')) return 'VEÍCULOS';
      if (path.includes('/supplies-manager')) return 'ABASTECIMENTOS';
      if (path.includes('/report/supplies')) return 'ABASTECIMENTOS';
      if (path.includes('/authorizations')) return 'AUTORIZAÇÕES';
      if (path.includes('/extra')) return 'EXTRAS';
      if (path.includes('/conferences/master')) return 'CONFERÊNCIAS';
      if (path.includes('/readjust/master')) return 'REAJUSTES';
      if (path.includes('/retroactivity/master')) return 'RETROATIVIDADE';
      if (path.includes('/blocked/master')) return 'BLOQUEADOS';
      if (path.includes('/report/master')) return 'RELATÓRIOS';
      if (path.includes('/report/tce')) return 'RELATÓRIOS TCE';
      if (path.includes('/users-manager')) return 'USUÁRIOS';
      if (path.includes('/access-groups')) return 'GRUPOS DE ACESSO';
      if (path.includes('/prefectures-manager')) return 'PREFEITURAS';
      if (path.includes('/providers-manager')) return 'FORNECEDORES';
      if (path.includes('/attendants-manager')) return 'FRENTISTAS';
      if (path.includes('/proprietario')) return 'PROPRIETÁRIOS';
      if (path.includes('/locador')) return 'LOCADORES';
      if (path.includes('/nfe')) return 'NOTAS FISCAIS';
      if (path.includes('/billings')) return 'FATURAMENTO';
      if (path.includes('/attendance-types')) return 'CONFIGURAÇÕES';
      if (path.includes('/fuels-types')) return 'CONFIGURAÇÕES';
      if (path.includes('/consumption-types')) return 'CONFIGURAÇÕES';
      if (path.includes('/bonds-types')) return 'CONFIGURAÇÕES';
      if (path.includes('/settings/logs')) return 'LOGS';

      // Fallback to route name or generic 'DASHBOARD'
      if (name === 'Dashboard' || name === 'dashboard') return 'PAINEL';
      
      return name ? name.toUpperCase() : 'PAINEL'; 
    }
  },
  watch: {
    // Watch for route changes to ensure reactivity in all conditions
    '$route'() {
      // Re-triggering computed property update if needed
      this.$forceUpdate();
    }
  },
  created() {
    this.initilizeTime();
  },  
  methods: {
    menu() {
      this.$store.dispatch("activeMenu", !this.$store.getters.getMenuState);
    },
    executeLogout() {
      sessionStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    },
    initilizeTime() {
      this.date = new Date().toLocaleDateString("pt-br");
      setInterval(() => {
        let time = new Date().toLocaleTimeString("pt-br");
        // Remove seconds for cleaner look if desired, keeping consistent with request
        this.time = time;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.page-title h1 {
  font-size: 1.25rem;
  font-weight: 900;
  font-style: italic;
  text-transform: uppercase;
  color: #333;
  letter-spacing: 0.5px;
  margin-top: 8px; /* Pequeno ajuste para descer o texto como solicitado */
}

.custom-header {
  padding-left: 80px !important;
}

.date-time-container {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 0.9rem;
  font-weight: 500;
}

.dt-item {
  display: flex;
  align-items: center;
}

.dt-divider {
  width: 1px;
  height: 16px;
  background-color: #ddd;
}

.user-name {
  font-weight: 700;
  color: #333;
  font-size: 0.85rem;
  text-transform: uppercase;
  line-height: 1.2;
}

.user-role {
  font-size: 0.7rem;
  color: #FF4600; /* Using the orange accent color for role */
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Search bar placeholder style */
.search-bar {
  background-color: #f5f5f5;
  padding: 8px 16px;
  border-radius: 20px;
  align-items: center;
  width: 250px;
}
</style>

// Este e o header da aplicacao. Possui o metodo menu onde e passado a uma variavel global (VUEX) para gerenciar a abertura e fechamento do menu.

esta funcao e uma action que e responsavel por atualizar o menu com o seu valor invertido.
this.$store.dispatch("activeMenu", !this.$store.getters.getMenuState);

foi importado um componente chamado Menu.